import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Import TSX providers
import { AuthProvider, AiLabProvider } from './context/AuthContext';
import { SocketProvider } from './context/SocketContext';
import { ThemeProvider } from './context/ThemeContext';
import { PortfolioProvider } from './context/PortfolioContext';
import { Toaster } from 'react-hot-toast';

// Register service worker (PWA support)
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/sw.js').catch(err => {
            console.warn('Service worker registration failed:', err);
        });
    });
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <ThemeProvider>
    <AuthProvider>
      <SocketProvider>
        <PortfolioProvider>
          <AiLabProvider>
            <Toaster position="top-center" />
            <App />
          </AiLabProvider>
        </PortfolioProvider>
      </SocketProvider>
    </AuthProvider>
  </ThemeProvider>
);

